module.exports = __webpack_public_path__ + "static/media/2.8976f447.jpg";